<div class="chart-empty d-flex flex-column justify-content-center align-items-center pt-lg-5">
    <div class="row text-center justify-content-center">
        <div class="col-12 col-lg-8">
            <div class="h5 text-primary">
                <!-- Hmmm...Looks like you don't have growth data for this time period. -->
            </div>
            <p>
                For the selected time period, we did not find any reviewed invoices. Kindly select an appropriate date
                range, or review the uploaded invoices.
            </p>
        </div>
    </div>
    <img src="assets/images/blank-state.gif"
        alt="empty chart"
        height="250" />
</div>